module.exports = __webpack_public_path__ + "img/productRobot_16.b1ce2550.png";